var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEasyPaymentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 118,
    viewBox: "0 0 118 118",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.2503 93.4167C44.2503 97.1042 43.2178 100.595 41.3987 103.545C38.0062 109.248 31.762 113.083 24.5837 113.083C17.4053 113.083 11.1612 109.248 7.76867 103.545C5.9495 100.595 4.91699 97.1042 4.91699 93.4167C4.91699 82.5508 13.7178 73.75 24.5837 73.75C35.4495 73.75 44.2503 82.5508 44.2503 93.4167Z",
    stroke: "white",
    strokeWidth: 7.375,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9199 93.4142L21.7874 98.2816L32.2599 88.5959",
    stroke: "white",
    strokeWidth: 7.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M87.2781 34.6623C86.0981 34.4656 84.8689 34.4165 83.5906 34.4165H34.4239C33.0472 34.4165 31.7197 34.5148 30.4414 34.7115C31.1297 33.3348 32.1131 32.0566 33.2931 30.8766L49.2722 14.8483C56.0081 8.16159 66.9231 8.16159 73.6589 14.8483L82.2631 23.5505C85.4097 26.648 87.0814 30.5814 87.2781 34.6623Z",
    stroke: "white",
    strokeWidth: 7.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M108.166 59.0001V83.5834C108.166 98.3334 98.333 108.167 83.583 108.167H37.5138C39.038 106.888 40.3655 105.315 41.398 103.545C43.2172 100.595 44.2497 97.1042 44.2497 93.4167C44.2497 82.5509 35.4488 73.7501 24.583 73.7501C18.683 73.7501 13.4222 76.3558 9.83301 80.4367V59.0001C9.83301 45.6267 17.8963 36.2851 30.4338 34.7117C31.7122 34.5151 33.0397 34.4167 34.4163 34.4167H83.583C84.8613 34.4167 86.0905 34.4659 87.2705 34.6625C99.9555 36.1375 108.166 45.5284 108.166 59.0001Z",
    stroke: "white",
    strokeWidth: 7.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEasyPaymentIcon);
export default __webpack_public_path__ + "static/media/easy_payment_icon.834ca4d945290140c8d5a530300df29a.svg";
export { ForwardRef as ReactComponent };